import {
  ClickAwayListener,
  Grid,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { Axle as AxleType } from 'core/types/axle';
import Slot from 'Elements/TireMap/Slot';

const Container = styled.div`
  margin-bottom: 10px;
`;

// Too many Axles hhhh
const Haxle = styled.div`
  background: #a8a8a8;
  width: 100%;
  height: 10px;
`;

type Props = {
  axle: AxleType;
  index: number;
  onDeleteClick: Function;
  isLast: boolean;
};

export default function Axle({ axle, index, onDeleteClick, isLast }: Props) {
  const [showPopper, togglePopper] = useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  return (
    <Container>
      <Grid container key={axle.id}>
        <Grid xs={2} item container justify="center">
          <Slot
            id={findSlotOnAxle(axle, 'VU')}
            axleId={axle.id}
            position={calculateSlotPosition(index, 1)}
          />
        </Grid>
        <Grid xs={2} item container justify="center">
          <Slot
            id={findSlotOnAxle(axle, 'VS')}
            axleId={axle.id}
            position={calculateSlotPosition(index, 2)}
          />
        </Grid>
        <Grid container justify="center" alignItems="center" item xs={4}>
          <Haxle ref={anchorRef} onClick={() => togglePopper(true)}></Haxle>
        </Grid>
        <Grid xs={2} item container justify="center">
          <Slot
            id={findSlotOnAxle(axle, 'OS')}
            axleId={axle.id}
            position={calculateSlotPosition(index, 3)}
          />
        </Grid>
        <Grid xs={2} item container justify="center">
          <Slot
            id={findSlotOnAxle(axle, 'OU')}
            axleId={axle.id}
            position={calculateSlotPosition(index, 4)}
          />
        </Grid>
      </Grid>
      {isLast && (
        <Popper
          open={showPopper}
          anchorEl={anchorRef.current}
          transition
          disablePortal
          placement="bottom"
        >
          <Paper>
            <ClickAwayListener onClickAway={() => togglePopper(false)}>
              <MenuList disablePadding>
                <MenuItem onClick={() => onDeleteClick(axle.id, index)}>
                  Poista akseli
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Popper>
      )}
    </Container>
  );
}

function calculateSlotPosition(row: number, offset: number): number {
  return row * 4 + offset;
}

function findSlotOnAxle(axle: AxleType, position: string): number | null {
  const slot = axle.slots.find(slot => slot.code === position);

  if (!slot) return null;

  return slot.id;
}
